<template>
    <b-modal :id="modalId" :title="storeTitle" hide-footer size="lg">
        <StoreInfos :storeId="storeId" />
    </b-modal>
</template>

<script>
    import StoreInfos from './StoreInfos.vue'

    export default {
        name : 'StoreModal',

        props : {
            modalId : {
                type : String,
                required : true,
            },
            storeId : {
                type : String,
                required : true,
            },
            storeTitle : {
                type : String,
                required : true,
            }
        },

        components : {
            StoreInfos,
        },
    }
</script>
